import React, { Component, type ReactElement } from 'react';
import { CameraImage } from './CameraImage';
import CameraInfo from './CameraInfo';
import type { CameraWrapperProps, CameraWrapperState } from './Cameras.types';

export class CameraWrapper extends Component<CameraWrapperProps, CameraWrapperState> {
    constructor(props: CameraWrapperProps) {
        super(props);

        this.state = {
            cameraUpdateTime: new Date(),
        };
    }

    onCameraUpdate = (updateTime: Date): void => {
        this.setState({
            cameraUpdateTime: updateTime,
        });
    };

    render(): ReactElement {
        return (
            <div className={'camera-wrapper d-flex flex-column ' + this.props.className}>
                <a className="camera-wrapper__link d-flex flex-column justify-content-between" href={this.props.url}>
                    {this.props.name && <h4>{this.props.name}</h4>}
                    <div className="camera-wrapper__image">
                        <CameraImage
                            id={this.props.pageId}
                            imageUrl={this.props.imageUrl}
                            noImageUrl={this.props.noImageUrl}
                            updateTime={20000}
                            title={this.props.name}
                            onUpdate={this.onCameraUpdate}
                            hasFullSizePhoto={this.props.hasFullSizePhoto}
                            showExpandButton={this.props.showExpandButton}
                        />
                    </div>
                </a>
                <CameraInfo
                    cameraPageId={this.props.pageId}
                    region={this.props.region}
                    showUpdateTime={this.props.showUpdateTime}
                    updatedTime={this.state.cameraUpdateTime}
                />
            </div>
        );
    }
}

export default CameraWrapper;
